import { init as initiateWorldReady } from './worldReadyData';

initiateWorldReady();
